/**
 * Runtime config for apps/web. The API base URL is env-driven (Vite `import.meta.env`,
 * see `.env.example`'s `VITE_API_BASE_URL`) rather than hardcoded, so this same bundle can be
 * pointed at a different API host (staging, docker-compose `api` profile, etc.) without a code
 * change. Falls back to the local dev default.
 */
export const API_BASE_URL: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "http://localhost:3000";
